import React from 'react';
import {graphql} from 'gatsby';
import styled from 'styled-components';
import ArrowIcon from '../assets/icons/arrow.svg';
import Logo from '../assets/icons/hth-colour-logo.png';
import Laterooms from '../assets/icons/laterooms-logo.png';
import LoadingIcon from '../assets/icons/loading.svg';
import Booking from '../assets/images/bookingcom.svg'

const Section = styled.section`
  position: absolute;
  top: 0;
  bottom: 0;
  background: var(--white);
  left: 0;
  right: 0;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
`;

const Content = styled.div`
  padding: 1.75rem 0;
  width: 100%;
  display: ${props => props.isLR && 'flex'};
  flex-direction: ${props => props.isLR && 'column'};
  align-items: ${props => props.isLR && 'center'};

  @media only screen and (min-width: 600px) {
    max-width: ${props=> props.isLR ? "40rem" : "35rem"};
  }
`;

const LogoGroup = styled.a`
  display: flex;
  flex-direction: column;
  text-decoration: none;
`;

const Copy = styled.div`
  padding: 0 1.25rem;
`;

const GroupText = styled.div`
  font-size: 0.75rem;
  margin-left: auto;
  font-style: italic;
  margin-top: .125rem;
  color: var(--black);
  @media only screen and (min-width: 600px) {
    margin-top: 0;
  }
`;

const Sub = styled.div`
  font-weight: bold;
  margin-top: 1.25rem;
  color: var(--black);
  font-weight: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    margin-top: .25rem;
  }
  @media only screen and (min-width: 600px) {
    display: block;
    white-space: nowrap;
    span:not(:last-child) {
      margin-right: 1rem;
    }
  }
`;

const Vertical = styled.span`
  display: none;
  @media only screen and (min-width: 600px) {
    display: initial;
  }
`;

const Title = styled.h2`
  margin-bottom: 1.25rem;
  font-size: 1.5rem;

  a {
    text-decoration: none;
    color: var(--black);
  }
`;

const Logos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 3rem 0;
  padding: 0 1.25rem;

  svg {
    height: 50px;

    &.laterooms {
      height: 25px;
      width: 100%;
    }
  }

  @media only screen and (min-width: 600px) {
    flex-direction: row;
    margin: 4rem 0 6rem;

    svg.laterooms {
        margin-left: 40px;
    }
  }
`;

const LogoImage = styled.img`
  width: auto;
  height: 4rem;
  object-fit: contain;
`;

const LateroomsLogoImage = styled.img`
  width: 100%;
  object-fit: contain;
  width: ${props => props.isLR ? "16rem" : "12rem"};

  @media only screen and (min-width: 600px) {
    width: ${props => props.isLR ? "19rem" : "28rem"};
  }
`;

const BookingLogoImage = styled.img`
  width: auto;
  height: 2rem;
  margin-top: 0.5rem;
  object-fit: contain;
  @media only screen and (min-width: 600px) {
    margin-left: 1.5rem;
  }
`;


const LoadingImage = styled.img`
  width: 8rem;
  margin-top: 1.25rem;
  @media only screen and (min-width: 600px) {
    margin-top: 1.75rem;
    width: 10rem;
  }
`;

const Arrows = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;

  img {
    -webkit-animation: ellipsis-dot 1s infinite;
    animation: ellipsis-dot 1s infinite;
  }

  .img:nth-child(1) {
    -webkit-animation-delay: 0.0s;
    animation-delay: 0.0s;
  }

  img:nth-child(2) {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
  }

  img:nth-child(3) {
    -webkit-animation-delay: 0.6s;
    animation-delay: 0.6s;
  }

  @-webkit-keyframes ellipsis-dot {
    0% {
      filter: invert(74%) sepia(12%) saturate(6%) hue-rotate(331deg) brightness(82%) contrast(80%);
    }

    75% {
      filter: invert(40%) sepia(63%) saturate(1439%) hue-rotate(341deg) brightness(102%) contrast(97%);
    }


    100% {
      filter: invert(74%) sepia(12%) saturate(6%) hue-rotate(331deg) brightness(82%) contrast(80%);
    }
  }

  @keyframes ellipsis-dot {
    0% {
      filter: invert(74%) sepia(12%) saturate(6%) hue-rotate(331deg) brightness(82%) contrast(80%);
    }

    75% {
      filter: invert(40%) sepia(63%) saturate(1439%) hue-rotate(341deg) brightness(102%) contrast(97%);
    }


    100% {
      filter: invert(74%) sepia(12%) saturate(6%) hue-rotate(331deg) brightness(82%) contrast(80%);
    }
  }

  @media only screen and (min-width: 600px) {
    flex-direction: row;
  }
`;

const Arrow = styled.img`
  height: 3rem;
  width: 3rem;
  transform: rotate(90deg);

  @media only screen and (min-width: 600px) {
    transform: rotate(0);
  }
`;

const Details = styled.div`
  border-top: 1px solid var(--drkGrey);
  padding: 1.25rem 1.25rem 0;

  b {
    display: block;
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }
`;

export default function RedirectPage({data}) {
    let finalUrl;

    const parameters = {};
    let region = '';
    let checkInDate = '';
    let checkOutDate = '';
    let snaptrip = "true";


    if (typeof location !== `undefined`) {
        finalUrl = location.href.includes('url=') ? location.href.split('url=')[1] : false;

        if (finalUrl) {
          let urlParts = finalUrl.split('?')[1].split('&')

          for ( const part of urlParts) {
              const singlePart = part.split('=')
              parameters[singlePart[0].replace('search[', '').replace(']', '')] = decodeURIComponent(singlePart[1])
          }

          checkInDate = parameters['check_in_on'] ? new Date(Date.parse(parameters['check_in_on'])): null;

          checkOutDate = checkInDate ? new Date(checkInDate) : null;

          checkInDate = checkInDate ? checkInDate.toLocaleDateString('en-GB') : null;

          let minimumNights = parseInt(parameters['minimum_nights']);

          checkOutDate ? checkOutDate.setDate(checkOutDate.getDate() + minimumNights) : null;

          checkOutDate = checkOutDate ? checkOutDate.toLocaleDateString('en-GB'): null;

          region = parameters['region'] ? parameters['region'].split(',')[0] : null;

          snaptrip = finalUrl.includes('snaptrip'); 
        }

    }

    setTimeout(function () {
        if (finalUrl && typeof window !== `undefined`) {
            window.location.href = finalUrl;
        } else if (!finalUrl) {
          window.location.href = window.location.origin;
        }
    }, 3000);

    return (
        <Section>
            {finalUrl && 
            (finalUrl.includes('www.laterooms') ? (
            <Content isLR>
                  <Title isLR>
                    Taking you to our sister site
                  </Title>
                <LogoGroup href="https://www.laterooms.com/" target="_blank" rel="noreferrer">
                    <LateroomsLogoImage isLR src={Laterooms} alt="Laterooms logo" />
                <GroupText>Part of the Snaptrip family</GroupText>
                </LogoGroup>
                <Sub>
                  <span>Exclusive member discounts</span>
                  <Vertical>|</Vertical>
                  <span>The biggest range of properties</span>
                  <Vertical>|</Vertical>
                  <span>The best price</span>
                </Sub>
              <LoadingImage src={LoadingIcon} alt="loading" />
            </Content>
          )
            : 
            <Content>
                <Copy>
                    <Title>
                        This search is provided by <br/>
                        { snaptrip ? 
                            <a href="https://www.snaptrip.com/" target="_blank">Snaptrip</a> :
                            <a href="https://www.laterooms.com/" target="_blank">LateRooms</a>
                        }
                    </Title>
                    <p>We're now transferring you...</p>
                </Copy>
                <Logos>
                    <a href="https://www.hottubhideaways.com/" target="_blank">
                        <LogoImage alt="Snaptrip logo" src={Logo}/>
                    </a>
                    <Arrows>
                        <Arrow src={ArrowIcon} alt="Right arrow"/>
                        <Arrow src={ArrowIcon} alt="Right arrow"/>
                        <Arrow src={ArrowIcon} alt="Right arrow"/>
                    </Arrows>
                    { snaptrip && <a href="https://www.snaptrip.com/" target="_blank">
                    <svg viewBox="0 0 139.72 54.75">
                        <g fill="#000">
                            <path d="M78.74,20.75l-.11-.05a4.46,4.46,0,0,0-4.19.42,10.66,10.66,0,0,0-3.74,4.94c-.21.46-.41.94-.61,1.43,0-.19.27-.88.28-1.06,0,0,1.66-5.76.52-6.24A2.21,2.21,0,0,0,68,20.8a13.15,13.15,0,0,0-1.48,4.67c-.12,1.28-.34,2.73-.42,4.53a11.07,11.07,0,0,1-.6,1,9.77,9.77,0,0,1-1.18,1.42,4.57,4.57,0,0,1-1.35,1,1,1,0,0,1-.83.11c-.68-.31-2-1.89.45-9.84A9,9,0,0,0,62.87,22a1.71,1.71,0,0,0-1.12-1.74,1.62,1.62,0,0,0-1.32-.17h0a7.19,7.19,0,0,0-4.79.45A15,15,0,0,0,50.91,24a29.32,29.32,0,0,0-2.21,2.72,20.57,20.57,0,0,0-1.83,3.11A14,14,0,0,0,45.81,33a5.91,5.91,0,0,0-.14,1.59c-1.08.74-1.66.59-1.84-.35-.1-.55-.17-1-.28-1.66a20.66,20.66,0,0,1-.26-2.13q-.09-1.14-.15-2.25a41.7,41.7,0,0,0-.43-4.2,3.73,3.73,0,0,0-1.78-2.87,2.46,2.46,0,0,0-1.38-.37,3.61,3.61,0,0,0-1.88.59,11.76,11.76,0,0,0-3.44,3.31L34,25l.24-.92c.23-.86.27-.88.48-1.51a1.34,1.34,0,0,1,.38-.7,1.91,1.91,0,0,0,0-2.58,1.83,1.83,0,0,0-2.78-.18,4.09,4.09,0,0,0-.82,1.14,5.25,5.25,0,0,0-.7,1.71c-.12.41-.24.57-.38,1.09L30,24.74,29.2,28.1c-.32,1.39-.67,3-1,4.77-.18.63-.33,1.17-.42,1.63l-.19.94c-.51,2.27,0,2.92,1.13,3.21A2,2,0,0,0,31,37.41c.21-.4.67-1.06,1.25-2.12.39-.73.94-1.68,1.64-2.83s1.44-2.32,2.2-3.45,1.51-2.13,2.23-3,.77-.69.82,1.19c0,.46.08.87.09,1.27q.09,1.35.21,2.7c.16,1.67.29,6.9,2.77,8.11,1.69.83,4.89-1.27,4.89-1.27.86,1.21,4.2,1.13,7.8-1.34a21.53,21.53,0,0,0,3-2.53,4.9,4.9,0,0,0,2.74,2.94,4.42,4.42,0,0,0,3.73,0,9.58,9.58,0,0,0,1.42-.83l-.06.91-.59,15.67a1.34,1.34,0,0,0,.19,1l.11.15c.11.11.23.23.38.36a1.71,1.71,0,0,0,1.14.37A1.84,1.84,0,0,0,68.63,54a1.63,1.63,0,0,0,.3-.86l.84-7.52c.39-2.69.22-1.43.75-4.29a8,8,0,0,0,4.35-1.8,16.49,16.49,0,0,0,4.28-5.33,19,19,0,0,0,1.63-3.73,15.36,15.36,0,0,0,.69-3.76,8.29,8.29,0,0,0-.54-3.42A5,5,0,0,0,78.74,20.75ZM55.5,30.88c-1.81,2.24-3.38,3.58-4.77,4.07s-2.18-1.72,1.13-6a28.34,28.34,0,0,1,1.89-2.31,9.93,9.93,0,0,1,3.72-2.61c.08,0,1.39-.58,1.24.52A15.27,15.27,0,0,1,55.5,30.88Zm22.38-4a16.39,16.39,0,0,1-2.13,5.43,16.37,16.37,0,0,1-2.69,3.58,5.69,5.69,0,0,1-1.63,1.18c.29-1.24.59-2.43.91-3.58.43-1.57.89-3,1.35-4.23a16.5,16.5,0,0,1,1.5-3.09,5.26,5.26,0,0,1,1.49-1.66C77.66,23.83,78,25.82,77.88,26.86Z"></path>
                            <path d="M99.22,20.86a5.81,5.81,0,0,0-4.08,1.76,14,14,0,0,0-1,1.13V23.6a6.45,6.45,0,0,0-.22-2,1.85,1.85,0,0,0-1-1.17,1.88,1.88,0,0,0-1.54,0,1.92,1.92,0,0,0-1,1A2,2,0,0,0,90.18,23a5.19,5.19,0,0,1,.11,1.76c0,1.11-.08,2.14-.19,3.56s-.22,2.66-.37,4-.28,2.48-.38,3.33a14.69,14.69,0,0,0-.16,1.54,2,2,0,0,0,1.89,2.41,1.67,1.67,0,0,0,1.44-.68,2.82,2.82,0,0,0,.44-.76,2.17,2.17,0,0,0,.12-.55,5,5,0,0,0,.21-1.22,5.72,5.72,0,0,1,.19-1.11c.26-1.11.6-2.32,1-3.58A24.84,24.84,0,0,1,96,28.2a11.24,11.24,0,0,1,1.74-2.55,2.07,2.07,0,0,1,1.51-.78,2,2,0,0,0,2-1.93,2.28,2.28,0,0,0-.45-1.43A1.69,1.69,0,0,0,99.22,20.86Z"></path>
                            <path d="M106.48,29.39c.1-1.07.17-1.91.23-2.5a27.8,27.8,0,0,0,.28-2.82,1.89,1.89,0,0,0-.55-1.39,2,2,0,0,0-2.84-.07A2,2,0,0,0,103,24c0,.22,0,.54,0,1s-.08.92-.14,1.49c-.32,3.48-.5,6.23-.54,8.18,0,2.16.24,3.62,1,4.56a2.07,2.07,0,0,0,1.48.65,1.69,1.69,0,0,0,1.22-.4,1.8,1.8,0,0,0,.45-2.67,3.54,3.54,0,0,1-.15-1.29c0-.87,0-1.83.07-2.89S106.39,30.45,106.48,29.39Z"></path>
                            <path d="M104.28,16.06a2.13,2.13,0,0,0-.7,1,1.68,1.68,0,0,0-.42,1.52,1.86,1.86,0,0,0,1.92,1.73h.23l.09,0a2.88,2.88,0,0,0,1-.37,2,2,0,0,0,.86-.91,1.93,1.93,0,0,0,.26-1,2.48,2.48,0,0,0-.5-1.44A1.84,1.84,0,0,0,104.28,16.06Z"></path>
                            <path d="M124.47,23.88a5.12,5.12,0,0,0-2.31-2.61,4.46,4.46,0,0,0-4.19.42,10.73,10.73,0,0,0-3.74,4.94c-.21.47-.41.94-.6,1.44,0-.2,0-.38,0-.57a24.23,24.23,0,0,0,0-2.9,4.29,4.29,0,0,0-.37-2,1.75,1.75,0,0,0-.76-.7A1.78,1.78,0,0,0,111,21.8a2.05,2.05,0,0,0-1.1.84,1.92,1.92,0,0,0-.15,1.81c0,.26.08-.1,0,1.49,0,1.4-.13,3.12-.22,5.15l-.88,19.24,0,1a1.41,1.41,0,0,0,.2,1l.11.15c.11.11.23.23.37.35a1.76,1.76,0,0,0,1.15.37,1.85,1.85,0,0,0,1.74-.73,1.72,1.72,0,0,0,.3-.85l.09-1.14c.25-2.55.58-3.31,1-6.21.1-.69.14-1,.16-1.12a9.5,9.5,0,0,0,.26-1.29,8,8,0,0,0,4.35-1.8,16.67,16.67,0,0,0,4.29-5.34,18.88,18.88,0,0,0,1.62-3.72,14.62,14.62,0,0,0,.69-3.76,8.29,8.29,0,0,0-.53-3.42Zm-3,3.63a17.85,17.85,0,0,1-2.19,5.36h0a16.35,16.35,0,0,1-2.7,3.57A5.47,5.47,0,0,1,115,37.62c.29-1.25.59-2.44.9-3.58.43-1.55.89-3,1.36-4.22a16,16,0,0,1,1.5-3.1,5.09,5.09,0,0,1,1.49-1.65C121.13,24.45,121.8,25.74,121.48,27.51Z"></path>
                            <path d="M133.91,4.32c-.24,1.17-.52,2.33-.75,3.51-.65,3.25-1.33,6.49-1.91,9.76-.52,2.91-1.52,8.84-1.95,11.62,0,.67-.05,1.2-.08,1.72a1,1,0,0,0,.49,1,1.72,1.72,0,0,0,2.66-1.11c.34-2.16,1.53-7.26,2.17-9.35,1.6-5.32,2.86-10.47,4.78-15.69C141.32.3,135.23-2,133.91,4.32Z"></path>
                            <path d="M130.7,34a2.58,2.58,0,0,0-3.77.69,5.31,5.31,0,0,0-.73,2.46,3.94,3.94,0,0,0,2.15,3.5,2,2,0,0,0,1,.21,2.4,2.4,0,0,0,2-1.1,6.78,6.78,0,0,0,.64-1.33A4,4,0,0,0,130.7,34Z"></path>
                            <path d="M108.89,8.76c-6.46.15-12.86.39-19.26.74l0-.16c.26-2,.45-3.42.56-4.36.16-1.35.19-.74.19-.92a1.88,1.88,0,0,0-.59-1.48,2,2,0,0,0-2.74,0A1.91,1.91,0,0,0,86.46,4c0,.09,0-.54-.22,1-.14,1.19-.3,2.56-.48,4.13l-.06.3,0,.33c-3.51.22-7,.46-10.54.75-2.59.22-3.86,4.34-.6,4.07,3.55-.3,7.09-.54,10.63-.76-.57,4.76-1.08,9.17-1.54,13.28-.5,4.49-.45,4.5-.78,7.81-.52,5.23,1.78,6,3.36,6A.84.84,0,0,0,87,39.73c-.5-1.24-.35-3.3,0-6.27.27-2.62.36-3.74.66-6.43s.59-5.31.89-7.86c.24-2.07.45-3.93.65-5.61,6.38-.35,12.75-.59,19.18-.74C110.91,12.76,112.15,8.69,108.89,8.76Z"></path>
                            <path d="M18.15,18.29c-5.16-3.82-6-4.26-5.86-6.72.16-3.21,4.79-7.33,12.25-7.21,8.83.15,13,2.84,13,4.56,0,1.42-1.4,1.43-4.08,2-.66.15-2.14.72-2,2,.17,2.21,7.5,1.62,9.61-1C46.16,5.74,34.54,1.16,29.33.42c-9.52-1.35-14.88.74-18.42,4s-7.22,10.25,2,15.85c6.72,4.55,9.19,7,9,11.63-.28,6.39-8.16,7.46-10.42,7.54a7.54,7.54,0,0,1-5.93-2c-2.35-2.72-.11-7.16,5.79-7.38a1.55,1.55,0,0,0,1.59-1.36c0-.44-.26-1.55-3.15-2.15-2.08-.42-5.78,1.08-8,4-1.95,2.6-2.5,6.07-.87,8.64C5,45.53,16.62,44.74,21.32,41.5c.74-.52,4.72-3.23,5.41-8.09C27.86,25.42,22.64,21.62,18.15,18.29Z"></path>
                        </g>
                    </svg>
                    </a> }
                    {finalUrl && finalUrl.includes("booking") &&
                    <a href="https://www.booking.com?aid=338955" target="_blank" rel="noreferrer">
                        <BookingLogoImage src={Booking} alt="booking.com logo" />
                    </a>}
                </Logos>
                { checkInDate && <Details>
                    <b>Search details</b>
                     <p>
                        {region}
                        &nbsp;{checkInDate}
                        &nbsp;to&nbsp;
                        {checkOutDate}
                    </p>
                </Details> }
            </Content>)}
        </Section>
    );
}

export const query = graphql`
	query redirectQuery {
		regions: allSanityRegion {
			nodes {
				name
				id
				slug {
					current
				}
			}
		}
		settings: sanitySiteSettings(_id: {eq: "siteSettings"})  {
			description
			id
			keywords
			primaryColor {
				hex
			}
			secondaryColor {
				hex
			}
			title
			logo {
				asset {
					fixed {
						src
					}
				}
			}
			favicon {
				asset {
					fixed(height: 48, width: 48) {
						src
					}
				}
			}
			image {
				asset {
				fixed(height: 600, width: 1200) {
					src
				}
				}
			}
		}
	}
`;